module.exports = __webpack_public_path__ + "img/scene7.77407c08.png";